import fetchClient from '../components/common/FetchClient';
import { authContext } from '../adalConfig';

const getUserIsEnabled = 'REQUEST_USER_IS_ENABLED';
const returnUserIsEnabled = 'RETURN_USER_IS_ENABLED';

const initialState = {
    
};

export const actionCreators = {

    getUserIsEnabled: queryData => async (dispatch, getState) => {

        dispatch({ type: getUserIsEnabled });

        const url = `/api/User/CheckValidUser`;

        fetchClient(url, {
            params: {
                azureToken: '',
                userId: authContext.getCachedUser().userName.replace("@empirepaper.com", '')
            }
        })
        .then(function (resp) {
            if (resp) {
                console.log('user security resp: ' + resp);

                dispatch({
                    type: returnUserIsEnabled,
                    enabled: resp.data
                });
            }
        });
    }

};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === getUserIsEnabled) {
        return {
            ...state,
            userId: action.userId,
            isLoading: true,
        };
    }
    if (action.type === returnUserIsEnabled) {
        return {
            ...state,
            enabled: action.enabled,
            isLoading: false,
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/UserEnabled.js